var dom = require('js-utils/dom');
var animate = require('js-utils/animate');
var echo = require('echo-js');

var autoId = 0;

export default function Slider(parentElem, options) {
	if (!(this instanceof Slider)) {
		return new Slider(parentElem, options);
	}

	this.id = autoId++;

	if ('production' !== process.env.NODE_ENV) {
		console.log('Slider', this.id, ': init', parentElem);
	}

	this.parentElem = parentElem;

	this.options = options;
	this.slides = dom.byClass(parentElem, 'slides')[0];
	this.currentSlide = null;
	this.currentAnimation = null;

	renderControls.call(this);

	this.controls = dom.byClass(parentElem, 'controls')[0];

	dom.on(this.parentElem, 'mouseenter', () => this.showControls(true));
	dom.on(this.parentElem, 'mouseleave', () => this.showControls(false));

	dom.on(this.parentElem, 'mousedown', onMouseDown.bind(this));
	dom.on(this.parentElem, 'touchstart', onMouseDown.bind(this));

	this.setPosition(0);
}

Slider.prototype.show = function show(index) {
	if ('production' !== process.env.NODE_ENV) {
		console.log('Slider', this.id, ': show from',
			this.currentSlide, 'to', index);
	}

	if (this.currentSlide === index) {
		return;
	}

	var w = this.parentElem.offsetWidth;

	if (null !== this.currentAnimation) {
		this.currentAnimation.cancel();
	}

	this.currentAnimation = animate(
		this.position,
		index * w,
		pos => {
			this.setPosition(pos);
			echo(window).init({offset: 2400});
		},
		{
			endCb: () => this.currentAnimation = null,
			ease: (n) => Math.sin(n * Math.PI / 2)
		}
	);

};

Slider.prototype.setPosition = function setPosition(pos, wrap) {
	if ('production' !== process.env.NODE_ENV) {
		console.log('Slider', this.id, ': setPosition pos:', pos);
	}

	if (pos === this.position) {
		return;
	}

	var slides = this.slides.children;
	var w = this.parentElem.offsetWidth;
	var wAll = (slides.length - 1) * w;

	if (wrap) {
		pos = pos % wAll;
		if (pos < 0) {
			pos = wAll + pos;
		}
	} else {
		if (pos < 0) {
			pos = 0;
		}

		if (wAll < pos) {
			pos = wAll;
		}
	}

	var index = pos / w;
	var aIndex = Math.floor(index);
	var bIndex = Math.ceil(index);
	var aElem = slides[aIndex];
	var bElem = slides[bIndex];

	if (aIndex === bIndex) {
		bElem = null;
	}

	dom.forEach(slides, s => {
		if (s === aElem || s === bElem) {
			dom.addClass(s, 'active');
		} else {
			dom.removeClass(s, 'active');
		}
	});

	var relPos = pos % w;

	if (0 === relPos) {
		aElem.style.left = '0px';
	} else {
		aElem.style.left = -relPos + 'px';
		bElem.style.left = (w - relPos) + 'px';
	}

	var relIndex = index - Math.floor(index);
	this.position = pos;
	this.currentSlide = relIndex < 0.5 ? aIndex : bIndex;

	var cSlides = dom.byClass(this.controls, 'slides')[0].children;
	dom.forEach(cSlides, s => {
		var cIndex = parseInt(s.getAttribute('data-index'));
		if (isNaN(cIndex)) {
			return;
		}

		var func =
			cIndex === this.currentSlide
				? dom.addClass
				: dom.removeClass;
		func(s, 'active');
	});
};

Slider.prototype.showControls = function showControlls(v) {
	if ('production' !== process.env.NODE_ENV) {
		console.log('Slider: showControls', v);
	}

	var func = v ? dom.addClass : dom.removeClass;
	func(this.parentElem, 'with-controls');
};

Slider.prototype.next = function next() {
	if ('production' !== process.env.NODE_ENV) {
		console.log('Slider', this.id, ': next');
	}

	if (this.currentSlide === this.slides.children.length - 1) {
		this.show(0);
	} else {
		this.show(this.currentSlide + 1);
	}

};

Slider.prototype.prev = function prev() {
	if ('production' !== process.env.NODE_ENV) {
		console.log('Slider', this.id, ': prev');
	}

	if (0 === this.currentSlide) {
		this.show(this.slides.children.length - 1);
	} else {
		this.show(this.currentSlide - 1);
	}
};

function renderControls() {
	var slidesLen = this.slides.children.length;

	if ('production' !== process.env.NODE_ENV) {
		console.log('Slider', this.id, ': render controls with',
			slidesLen, 'slides');
	}

	var html =
		'<div class="prev"></div>' +
		'<div class="next"></div>';

	html += '<div class="slides">';
	for (var i = 0; i < slidesLen; ++i) {
		html += `<div class="slide" data-index="${i}"></div>`;
	}
	html += '</div>';

	var div = document.createElement('div');
	div.className = 'controls';
	div.innerHTML = html;

	dom.on(dom.byClass(div, 'prev')[0], 'click', this.prev.bind(this));
	dom.on(dom.byClass(div, 'next')[0], 'click', this.next.bind(this));
	dom.on(dom.byClass(div, 'slides')[0], 'click', e => {
		var index = parseInt(e.target.getAttribute('data-index'));
		if (!isNaN(index)) {
			this.show(index);
		}
	});

	this.parentElem.appendChild(div);
}

var mouseActive = false;
var mouseX = 0;
var mousePos = 0;
var mouseSlide = null;
var activeSlider = null;

function onMouseDown(e) {
	if (e.type === 'mousedown') {
		e.preventDefault();
	}
	if (null !== this.currentAnimation) {
		this.currentAnimation.cancel();
	}
	activeSlider = this;
	mouseActive = true;
	mouseX = mouseEventGetPos(e).x;
	mousePos = this.position;
	mouseSlide = this.currentSlide;
}

function onMouseUp(e) {
	if (!mouseActive) {
		return;
	}

	if (e.type === 'mouseup') {
		e.preventDefault();
	}

	var pos = mousePos + mouseX - mouseEventGetPos(e).x;
	if (mousePos <= pos) {
		activeSlider.show(mouseSlide + 1);
	} else {
		activeSlider.show(mouseSlide - 1);
	}

	mouseActive = false;
	activeSlider = null;
}

function onMouseMove(e) {
	if (!mouseActive) {
		return;
	}

	if (e.type === 'mousemove') {
		e.preventDefault();
	}
	var pos = mousePos + mouseX - mouseEventGetPos(e).x;
	activeSlider.setPosition(pos);
}

dom.on('touchmove', onMouseMove);
dom.on('mousemove', onMouseMove);
dom.on('mouseup', onMouseUp);
dom.on('touchend', onMouseUp);

function mouseEventGetPos(e) {
	var touch = e.changedTouches
		&& e.changedTouches[0]
		&& e.changedTouches[0].clientX
		&& e.changedTouches[0].clientY;

	return {
		x: touch ? e.changedTouches[0].clientX : e.clientX,
		y: touch ? e.changedTouches[0].clientY : e.clientY
	};
}
